import * as R from 'ramda';

import elementIcon from '@atom/components/common/svgIcons/elementIcon.svg';
import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import schemaUtilities from '@atom/utilities/schemaUtilities';

import { isAsset } from './InventoryAssetTreeTransfer';
import { Tree } from './TreeContext';

export interface Props {
  tree: Tree;
}

const styles = {
  icon: {
    marginRight: '0.5rem',
  },
};

const TreeRowIcon = ({ tree }: Props) => {
  // category icon
  if (!isAsset(tree)) {
    return (
      <Icon
        color={
          tree.colorId
            ? schemaUtilities.getSchemaColorFromColorId(tree.colorId)
            : colors.neutral.gray
        }
        style={styles.icon}
      >
        folder
      </Icon>
    );
  }

  // material asset icon
  if (tree.isMaterial) {
    return (
      <Icon
        color={schemaUtilities.getSchemaColorFromColorId(tree.colorId)}
        style={styles.icon}
      >
        category
      </Icon>
    );
  }

  // location based asset icon
  // @ts-ignore
  return R.isNil(tree.markerId) || tree?.isSubItem ? (
    <img style={styles.icon} src={elementIcon} />
  ) : (
    <img
      style={styles.icon}
      src={schemaUtilities.getSchemaIconFromMarkerId(tree.markerId)}
    />
  );
};

export default TreeRowIcon;
